import { DirectUpload } from '@rails/activestorage';
import { $, $$, $e, tap } from './utils';

let config = { css: [] };
tap($('tinymce-config'), (cfg) => {
  config = JSON.parse(cfg.textContent);
  if (window.tinymce) init();
});

function init() {
  const googleFonts = [...$$('link[rel=stylesheet][href*="fonts.googleapis"]')].map((el) => el.href);
  tinymce.init({
    license_key: 'gpl',
    language: 'ja',
    selector: '.tinymce',
    width: computeWidth(),
    content_css: [...googleFonts, ...config.css],
    body_class: 'prose',
    plugins: ['lists', 'link', 'image', 'media', 'code'],
    toolbar: [
      'undo redo | blocks | bold italic | alignleft aligncenter alignright | link image media | bullist numlist',
    ],
    toolbar_sticky: true,
    default_font_stack: ['Noto Sans JP,sans-serif'],
    font_family_formats: 'ゴシック=Noto Sans JP,sans-serif; 明朝=Noto Serif JP,serif',
    link_default_protocol: 'https',
    relative_urls: false,
    file_picker_types: 'image media',
    file_picker_callback: (cb, value, meta) => {
      const input = $e('input', { type: 'file', accept: meta.filetype === 'image' ? 'image/*' : 'video/*' });
      input.addEventListener('change', (ev) => {
        const file = ev.target.files[0];
        if (file) upload(file).then((res) => cb(res.location), alert);
      });
      input.click();
    },
  });
}

function computeWidth() {
  const gutter = window.innerWidth - document.body.scrollWidth;
  // var(--container-4xl) - width of .text-right
  // var(--spacing) * 6   - px-3
  // gutter               - scrollbar gutter
  // 4                    - border of tinymce frame
  return `calc(min(var(--tinymce-max-width), var(--container-4xl) + var(--spacing) * 6 + ${gutter + 4}px))`;
}

function dispatch(type, detail) {
  document.body.dispatchEvent(new CustomEvent(type, { bubbles: true, cancelable: true, detail }));
}

async function upload(file) {
  dispatch('direct-uploads:start');
  dispatch('direct-upload:start', { file });
  try {
    const upload = new DirectUpload(file, config.upload, {
      directUploadWillStoreFileWithXHR(xhr) {
        xhr.upload.addEventListener('progress', (ev) => {
          const progress = (ev.loaded / ev.total) * 100;
          if (progress) dispatch('direct-upload:progress', { file, progress });
        });
      },
    });
    const attributes = await new Promise((resolve, reject) => {
      upload.create((error, attributes) => {
        if (error) reject(error);
        else resolve(attributes);
      });
    });
    return { location: `/media/${attributes.key}` };
  } finally {
    dispatch('direct-upload:end', { file });
    dispatch('direct-uploads:end');
  }
}
